export interface NewsArticle {
  id: number;
  image: string;
  date: string;
  title: string;
  description: string;
  content: string;
}

export const newsArticles: NewsArticle[] = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=church%20community%20volunteers%20serving%20food%20at%20charity%20event%20helping%20people%20warm%20atmosphere%20smiling%20faces%20teamwork%20compassion%20simple%20clean%20background%20community%20service%20outreach%20program&width=800&height=600&seq=news-001&orientation=landscape',
    date: '2025년 3월 15일',
    title: '지역사회 봉사 프로그램 성공적 마무리',
    description: '최근 진행된 지역사회 봉사 프로그램을 통해 200여 가정에 도움을 전달했습니다. 함께해 주신 모든 봉사자분들께 감사드립니다.',
    content: `최근 진행된 지역사회 봉사 프로그램이 큰 성공을 거두며, 지역 내 200여 가정에 따뜻한 손길을 전했습니다. 2월 한 달간 진행된 이 프로그램에는 교회 전체에서 봉사자들이 모여 어려운 이웃들을 섬겼습니다.

이번 프로그램은 주간 식품 배분 센터, 의류 나눔, 무료 건강 검진 등 여러 핵심 활동으로 구성되었습니다. 봉사자들은 500시간 이상을 헌신하며 모든 가정이 필요한 지원을 받을 수 있도록 최선을 다했습니다.

특히 감동적이었던 것은 청년부의 적극적인 참여였습니다. 13세부터 18세까지의 청소년들이 기부품 모으기, 물품 정리, 직접 가정 방문 봉사에 참여했습니다. 그들의 열정과 사랑은 정말 감동적이었습니다.

"이번 경험이 봉사에 대한 제 생각을 바꿔놓았어요." 16세 봉사자 민지가 나눴습니다. "우리가 도움을 드릴 때 사람들의 눈에서 보이는 감사함이 왜 우리 믿음이 이웃 사랑을 부르는지 깨닫게 해줬어요."

식품 배분 센터에서는 식량 불안정에 처한 가정들에게 신선한 농산물, 비상식품, 필수 생활용품을 제공했습니다. 교회와 지역 기업들의 넉넉한 기부 덕분에 각 가정에 2주 분량의 물품을 전달할 수 있었습니다.

의류 나눔에서는 겨울 코트, 아동복, 면접용 정장 등 1,000점 이상의 의류를 모았습니다. 지역 단체들과 협력하여 가장 필요한 분들에게 전달했습니다.

지역 보건소와 협력하여 진행한 무료 건강 검진에서는 혈압 측정, 당뇨 검사, 일반 건강 상담을 제공했습니다. 많은 참가자들이 만성 질환 관리에 대한 유용한 정보를 얻고 지속적인 의료 서비스와 연결되었습니다.

앞으로 이 봉사 프로그램을 매월 지속할 계획입니다. 또한 추가 지역 단체들과의 협력을 통해 서비스를 확대하고자 합니다. 봉사에 관심이 있거나 도움이 필요한 분을 아신다면 봉사 담당자에게 연락해 주세요.

이 프로그램의 성공을 위해 시간, 자원, 기도로 함께해 주신 모든 분들께 감사드립니다. 함께 우리는 사랑과 긍휼로 지역사회를 섬기는 사명을 실천하고 있습니다.`
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=church%20youth%20group%20teenagers%20singing%20worship%20music%20together%20guitars%20instruments%20joyful%20expressions%20modern%20church%20setting%20simple%20background%20youth%20ministry%20praise%20and%20worship&width=800&height=600&seq=news-002&orientation=landscape',
    date: '2025년 3월 10일',
    title: '청년부 봄 수련회 안내',
    description: '예배, 교제, 영적 성장이 함께하는 잊지 못할 주말을 함께하세요. 13-18세 청소년 등록이 시작되었습니다.',
    content: `청년부 봄 수련회를 안내드립니다. 2025년 4월 18일부터 20일까지 소나무 호수 수련원에서 진행됩니다. 이 3일간의 행사는 13세부터 18세까지의 학생들에게 예배, 교제, 영적 성장의 잊지 못할 경험이 될 것입니다.

이번 수련회 주제는 "믿음에 뿌리내리기"로, 청소년 시기에 그리스도 안에서 견고한 기초를 세우는 것이 무엇을 의미하는지 탐구합니다. 역동적인 예배, 소그룹 나눔, 재미있는 레크리에이션 활동을 통해 학생들은 하나님과의 관계를 깊게 하고 평생의 우정을 쌓을 기회를 갖게 됩니다.

일정에는 아침 묵상, 청년 담당 김성민 목사님이 인도하는 대화형 강의, 청년 찬양팀의 라이브 음악이 함께하는 저녁 예배가 포함됩니다. 하이킹, 카누, 팀 빌딩 챌린지 등 야외 활동 시간도 충분히 마련되어 있습니다.

특별 강사로 서울에서 활동하는 저명한 청년 사역자 박은혜 목사님이 토요일 저녁 메인 세션에 함께합니다. 박 목사님은 청소년들과 소통하고 하나님의 계획 안에서 그들의 목적을 발견하도록 돕는 은사가 있습니다.

수련회 비용은 학생당 15만원이며, 모든 식사, 숙박, 활동이 포함됩니다. 재정적 도움이 필요한 가정을 위한 장학금이 마련되어 있으니 김성민 목사님께 비밀리에 말씀해 주세요. 조기 등록(3월 25일 이전)시 2만5천원 할인됩니다.

교회 버스로 이동하며, 금요일 오후 3시에 출발하여 일요일 오후 5시에 돌아옵니다. 원하시면 수련원에서 직접 픽업/드롭오프도 가능합니다.

준비물: 성경, 노트, 야외 활동용 편한 옷, 침낭, 세면도구, 필요한 약. 등록 시 상세 준비물 목록을 제공합니다.

등록이 시작되었으며 60명으로 제한됩니다. 교회 로비의 청년부 테이블이나 웹사이트에서 온라인으로 신청하세요. 믿음과 교제 안에서 성장할 이 놀라운 기회를 놓치지 마세요!

문의사항은 청년부 담당 김성민 목사님(youth@gracecommunitychurch.org)이나 교회 사무실(02-123-4567)로 연락해 주세요.`
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=easter%20sunday%20celebration%20church%20decorated%20with%20white%20lilies%20and%20spring%20flowers%20bright%20joyful%20atmosphere%20resurrection%20celebration%20simple%20elegant%20background%20festive%20church%20interior&width=800&height=600&seq=news-003&orientation=landscape',
    date: '2025년 3월 5일',
    title: '부활절 예배 안내',
    description: '부활의 기쁨을 함께 나누세요! 다양한 예배 시간이 준비되어 있습니다. 어린이 프로그램과 친교 식사도 함께합니다.',
    content: `부활절이 다가오고 있습니다. 2025년 4월 20일, 예수 그리스도의 부활을 함께 기념하도록 초대합니다. 올해 부활절 행사는 다양한 예배 시간, 특별 프로그램, 온 가족이 부활절의 기쁨을 경험할 수 있는 기회로 가득합니다.

예배 시간:
- 새벽 예배: 오전 6시 30분 (야외 원형극장, 날씨 허락 시)
- 1부 예배: 오전 9시 (본당)
- 2부 예배: 오전 11시 (본당)
- 영어 예배: 오후 1시 (친교실)

각 예배에서는 감동적인 찬양, 부활에 대한 강력한 메시지, 기도와 묵상의 시간이 마련됩니다. 성가대와 찬양팀이 여러분의 영혼을 고양시키고 그리스도의 승리를 기념하는 특별한 음악을 준비했습니다.

새벽 예배는 은혜공동체교회의 사랑받는 전통입니다. 해가 뜰 때 함께 모여 빈 무덤을 기억하며 예배드립니다. 담요나 접이식 의자를 가져오시고 따뜻하게 입으세요. 비가 올 경우 소예배실로 이동합니다.

부활절 아침 식사:
오전 9시와 11시 예배 사이에 친교실에서 무료 부활절 아침 식사에 함께하세요. 팬케이크, 계란, 신선한 과일과 함께 교회 가족과의 교제를 즐기세요. 예약 필요 없이 누구나 환영합니다!

어린이 부활절 프로그램:
오전 9시와 11시 예배 동안 3-10세 어린이들은 특별 부활절 프로그램에 참여할 수 있습니다. 대화형 스토리텔링, 만들기, 연령에 맞는 활동을 통해 어린이들이 재미있고 흥미롭게 부활에 대해 배웁니다.

부활절 달걀 찾기:
오전 11시 예배 직후, 2-10세 어린이들은 교회 잔디밭에서 열리는 연례 부활절 달걀 찾기에 참여할 수 있습니다. 간식과 상품이 들어있는 수천 개의 달걀이 연령별 구역에 숨겨져 있습니다.

역사상 가장 위대한 사건인 우리 주 예수 그리스도의 부활을 함께 기념합시다. 주님이 참으로 살아나셨습니다!`
  }
];
